import { useSilentEmailVerificationStore } from '#player-verification/app/stores/silentEmailVerification'

const SILENT_EMAIL_VERIFICATION_TOKEN_QUERY = 'silentEmailVerificationToken'

export default defineNuxtRouteMiddleware(({ query }) => {
  if (import.meta.server) return

  const token = query[SILENT_EMAIL_VERIFICATION_TOKEN_QUERY]
  if (!token) return

  if (Array.isArray(token)) {
    return navigateTo({
      query: R_omit(query, [SILENT_EMAIL_VERIFICATION_TOKEN_QUERY]),
      replace: true,
    })
  }

  const { setToken } = useSilentEmailVerificationStore()
  setToken(token)
  return navigateTo({
    query: R_omit(query, [SILENT_EMAIL_VERIFICATION_TOKEN_QUERY]),
    replace: true,
  })
})
